import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

import { getAffirmativeOptions } from '../../../utils/data';


class EquipmentSummaryForm extends Form {
	state = {
		data: {
			equipmentNumber: '',
			hasAnomalies: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		equipmentNumber: Joi.string().min(3).required().label('Equipment Tag'),
		hasAnomalies: Joi.string().min(2).required().label('Has Anomalies'),
	};

	static propTypes = {
		initialData: PropTypes.object,
		onSave: PropTypes.func,
	};
	
	componentDidMount(): void {
		if (this.props.initialData) {
			this.setState({ data: this.props.initialData });
		}
	}

	doSubmit = (): void => {
		this.props.onSave(this.state.data);
		toastService.success('Equipment Summary Saved Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipmentNumber',
							placeholder: 'Enter Equipment Tag',
							label: 'Equipment Tag',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'hasAnomalies',
							placeholder: 'Does this equipment have any anomalies?',
							label: 'Has Anomalies:',
							options: getAffirmativeOptions(),
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Information')}
				</div>
			</form>
		);
	}
}

export default EquipmentSummaryForm;
